import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_72ivqmkinu: FaireBrandEntity = {
  token: "b_72ivqmkinu",
  type: "brand",
  name: "Crover",
  avatarUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c2bdab4240fbc43878308ee946a4e38369a92d026088a002840de416b91d38ca.png",
  logoUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c2bdab4240fbc43878308ee946a4e38369a92d026088a002840de416b91d38ca.png",
  location: "Vernon, CA, USA",
  minimumOrderDollars: 99,
  rating: 4.9,
  reviewCount: 74,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded in the heart of California, Crover Inc began with a simple mission: to bring high-quality home essentials to everyday consumers at unbeatable prices. What started as a local distribution network has now grown into a trusted name in the wholesale industry, known for reliability, affordability, and a relentless focus on customer satisfaction.\n\nAt Crover Inc, we believe that comfort and quality should be accessible to everyone. That’s why we source directly from top manufacturers, cutting out unnecessary costs and passing the savings on to our customers. From cozy blankets and bedding to functional home goods, every product we carry is chosen with care to meet our strict standards for performance and durability.\n\nAs a dynamic company, we’ve expanded across leading online marketplaces, allowing businesses of all sizes to access our wide selection of goods seamlessly. Whether you’re a small retailer, an e-commerce entrepreneur, or a global distributor, Crover Inc is your reliable partner in growth.\n\nDriven by innovation, integrity, and a people-first approach, Crover Inc isn’t just a wholesale supplier—we’re a brand built on long-term relationships and everyday value. Wherever you are, we’re here to deliver—Anywhere. Anytime. To Everyone.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:44.188Z",
    importedBy: "entity-db-cli",
  },
};
